export const sanitizeHTML = (dirtyHtml) => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(dirtyHtml, 'text/html')
  
    const dangerousTags = ['script', 'iframe', 'object', 'img', 'svg', 'video']
    const forbiddenAttrs = ['src', 'href']
    
    // Remove dangerous elements
    dangerousTags.forEach(tag => {
      const elements = doc.querySelectorAll(tag)
      elements.forEach(el => el.remove())
    })
  
    // Walk all nodes and clean attributes
    const walkAndClean = (node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        // Remove event handler attributes (e.g., onclick)
        for (const attr of [...node.attributes]) {
          if (attr.name.startsWith('on')) {
            node.removeAttribute(attr.name)
          }
          if (forbiddenAttrs.includes(attr.name)) {
            node.removeAttribute(attr.name)
          }
        }
  
        // Recurse into children
        for (const child of node.children) {
          walkAndClean(child)
        }
      }
    }
  
    walkAndClean(doc.body)
    return doc.body.innerHTML
  }
  